<template>
  <div id="login-wg" class="container">
    <form class="login" @submit.prevent="resetPassword">
      <div class="row">
        <h1><i class="fa fa-lock" aria-hidden="true"></i> Password reset</h1>
      </div>
      <br />
      <div :class="{ auth_error_msg: errored }">
        {{ message }}
      </div>
      <br />

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-user-tie"></i>
          </span>
        </div>
        <input
          type="email"
          class="form-control"
          placeholder="Confirm email"
          required
          v-model="email"
        />
      </div>
      <br />

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa fa-key icon"></i>
          </span>
        </div>
        <input
          required
          v-model="password"
          type="Password"
          name
          class="form-control"
          placeholder="New password"
        />
      </div>

      <br />
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa fa-key icon"></i>
          </span>
        </div>
        <input
          required
          v-model="password_confirmation"
          type="Password"
          name
          class="form-control"
          placeholder="Password confirmation"
        />
      </div>
      <br />
      <button type="submit" class="form-control btn btn-success btn-login">
        <span class="glyphicon glyphicon-off"></span>Change password
      </button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    request_id: String,
  },
  data() {
    return {
      loading: true,
      errored: false,
      email: "",
      password: "",
      password_confirmation: "",
      message: "Please confirm your email and type a new password",
    };
  },

  methods: {
    resetPassword: function() {
      if (this.password != this.password_confirmation) {
        this.$toast.error("The passwords doesn't match...", {
          position: "top",
        });
      } else {
        let email = this.email;
        let password = this.password;
        let request_id = this.request_id;

        axios({
          url: "AUTH/V1/REQUEST",
          data: { request_id, email, password },
          method: "POST",
        })
          .then((resp) => {
            this.errored = false;
            this.message = "Your password have been succesfully updated";
            localStorage.setItem("token", resp.data.token);
            this.$toast.success(this.message, {
              position: "top",
              onClose: () => this.$router.push("/portal"),
            });
          })
          .catch((error) => {
            this.errored = true;
            this.message = error.response.data.fault.detail;
            this.$toast.error(this.message, {
              position: "top",
            });
          });
      }
    },
  },
};
</script>
